export const theme = {
  colors: {
    primary: '#14DACC',     // Ana tema rengi (turkuaz)
    secondary: '#A1F7A0',   // İkincil tema rengi (açık yeşil)
    accent: '#14DACC',      // Vurgu rengi olarak ana rengi kullanıyoruz
    background: '#FFFFFF',  // Arka plan (istendiği üzere beyaz)
    darkBackground: '#F5F5F5', // Koyu arka plan (açık gri)
    text: '#333333',        // Metin rengi (koyu gri)
    lightText: '#666666',   // Açık metin rengi (orta gri)
    border: '#EEEEEE',      // Kenarlık rengi (açık gri)
    success: '#28a745',     // Başarı mesajları (yeşil)
    error: '#F43F5E',       // Hata mesajları (kırmızı)
    warning: '#FF934F',     // Uyarı mesajları (turuncu)
    blue: '#3B82F6',        // Mavi
  },
  fonts: {
    main: "'Poppins', 'Roboto', sans-serif",
    heading: "'Poppins', 'Roboto', sans-serif",
  },
  breakpoints: {
    xs: '480px',
    sm: '768px',
    md: '992px',
    lg: '1200px',
  },
  shadows: {
    small: '0 2px 8px rgba(0, 0, 0, 0.1)',
    medium: '0 4px 12px rgba(0, 0, 0, 0.1)',
    large: '0 8px 24px rgba(0, 0, 0, 0.1)',
  },
  borderRadius: {
    small: '4px',
    medium: '8px',
    large: '16px',
    round: '50%',
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px',
  },
  transitions: {
    short: 'all 0.2s ease',
    medium: 'all 0.3s ease',
    long: 'all 0.5s ease',
  },
};

export type Theme = typeof theme; 